var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.uid + '',staticClass:"search-item"},[_vm._t("before"),_c('span',{class:{ske: _vm.ske, 'forced-ske': _vm.forcedSke}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }